import { Injectable } from '@angular/core';
import { DeviceService } from './device.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class URLService {
  public mapping: any;
  private isAngularLoading: BehaviorSubject<boolean>;
  private isLoading: boolean;
  private tabSelected: BehaviorSubject<string> = new BehaviorSubject<string>('hotels');

  constructor(public deviceService: DeviceService) {
    const from = 'ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç´';
    const to = 'AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuuNnCc-';
    this.mapping = {};
    for (let i = 0, j = from.length; i < j; i++) {
      this.mapping[from.charAt(i)] = to.charAt(i);
    }
  }

  public isLoading$(): Observable<boolean> {
    return this.isAngularLoading.asObservable();
  }

  public startLoading(): void {
    this.isLoading = true;
    this.isAngularLoading = new BehaviorSubject<boolean>(this.isLoading);
  }

  public toggleLoanding(): void {
    this.isLoading = !this.isLoading;
    this.isAngularLoading.next(!this.isAngularLoading.value);
  }

  public setCurrentTab(isDisney: boolean) {
    const tab = isDisney ? 'disney' : 'hotels';
    this.tabSelected.next(tab);
  }

  public currentTab() {
    return this.tabSelected.asObservable();
  }

  public normalizeUrl(str: string) {
    const ret = [];
    for (let i = 0, j = str.length; i < j; i++) {
      const c = str.charAt(i);
      // eslint-disable-next-line no-prototype-builtins
      if (this.mapping.hasOwnProperty(str.charAt(i))) {
        ret.push(this.mapping[c]);
      } else {
        ret.push(c);
      }
    }
    const result = ret.join('').toLowerCase().split(' ').join('-');
    return result;
  }

  public getResizeUrl(imageUrl: string, section: string) {
    const sizes = {
      result: {
        desktop: 319,
        tablet: 752,
        mobile: 360,
      },
      detail: {
        desktop: 1600,
        tablet: 637,
        mobile: 360,
      },
    };

    const env = location.host.split('.')[0];
    let environment = '';

    switch (env) {
      case 'st':
      case 'dev':
      case 'localhost':
        environment = 'st.';
        break;
      case 'ccr':
      case 'sucursales':
        environment = '';
        break;
    }

    const size = sizes[section]?.[this.deviceService.getDeviceString()] ?? 360;

    if (!imageUrl) {
      return `https://${environment}images.almundo.com/205/image/fetch/fl_progressive,q_auto,c_fill,g_auto,w_${size}/`;
    }

    if (imageUrl.includes('/image/fetch/')) {
      return imageUrl;
    }

    if (imageUrl.includes('https://st.images')) {
      imageUrl = imageUrl.replace('https://st.images', 'https://images');
    }

    return `https://${environment}images.almundo.com/205/image/fetch/fl_progressive,q_auto,c_fill,g_auto,w_${size}/${imageUrl}`;
  }



}
